export class AddContactDto {
    email!: string;
    name!: string;
    phone: string;
    position: string;
    imageUrl: string;
    notes: string;
}